import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Select.css";

const Select = props => {
  const { className, ...other } = props;
  const classInline = props.position === "inline" ? "ui-select--inline" : "";
  return (
    <div className={"ui-select " + " " + classInline + " " + className}>
      <label>{props.label}</label>
      {props.error?<span className="form-error-message">{props.error}</span>:""}
      <select {...other}>{props.children}</select>
    </div>
  );
};

Select.propTypes = {
  /** ClassName will be injected into the component's container. You can use ClassName for adhoc styling. */
  className: PropTypes.string,
  /** The label of the checkbox */
  label: PropTypes.string,
  /** Optional set the select to "inline" to remove select borders. */
  position: PropTypes.string,
  /** Required. The objects that will be rendered beside the select (option tags). */
  children: PropTypes.element.isRequired
};

Select.defaultProps = {
  className: "",
  label: "",
  position: ""
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/UI/Select/Select.js